/**
 * 如果自定义域名数据信息,需要挂载到 window._customDomain 上
 */
// 控制台域名地址
window.domainOfConsole = function () {
  return (window._customDomain?.console_domain || process.env.VUE_APP_WEB_BASE)
    .toLowerCase()
    .replace(/^https?:/, '');
};

// 发起端域名地址
window.domainOfLive = function () {
  return (window._customDomain?.console_domain || process.env.VUE_APP_WEB_BASE)
    .toLowerCase()
    .replace(/^https?:/, '');
};

// 观看端域名地址
window.domainOfWatch = function () {
  return (window._customDomain?.watch_domain || process.env.VUE_APP_WAP_WATCH)
    .toLowerCase()
    .replace(/^https?:/, '');
};
